import { useDevice } from 'components/DeviceContext.js';


function Rodape() {
    const {isMobile, isLaptop, isDesktop} = useDevice();
    return (
        <footer style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: 'var(--azul)',
            fontSize: isMobile ? '0.9em' : isLaptop ? '0.8em' :  isDesktop ? '1em' : '',
            color: 'var(--branco)',
            padding: isMobile ? '0.5em': '0'
        }}>
            <p style={{}}> © 2024 Confederação Nacional de Municípios. Todos os direitos reservados. Todo o conteúdo produzido pode ser reproduzido, desde que citada a fonte.</p>
        </footer>
    )
}

export default Rodape;
